import { render, staticRenderFns } from "./EquipoCliente.vue?vue&type=template&id=0e2c1bc4&"
import script from "./EquipoCliente.vue?vue&type=script&lang=ts&"
export * from "./EquipoCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0e2c1bc4', component.options)
    } else {
      api.reload('0e2c1bc4', component.options)
    }
    module.hot.accept("./EquipoCliente.vue?vue&type=template&id=0e2c1bc4&", function () {
      api.rerender('0e2c1bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/EquipoCliente.vue"
export default component.exports